import React, { forwardRef } from 'react';
import {
	Card,
	CardHeader,
	CardMedia,
	CardContent,
	Checkbox,
	IconButton,
} from "@material-ui/core";
import { Pencil, Trash } from "react-bootstrap-icons";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";

const CarrosselCard = forwardRef(({ image, imageUrl, hasEditPermission, selected, onSelectChange, onEdit, onDelete, dragHandleProps, style, isDragging }, ref) => {
	const handleImageClick = () => {
		if (image.link && image.link.trim() !== '') {
			window.open(image.link, '_blank');
		} else {
			window.open(imageUrl, '_blank');
		}
	};

	return (
		<Card
			ref={ref}
			className={ `carrossel-card${ selected ? ' carrossel-card--selected' : '' }${ isDragging ? ' carrossel-card--dragging' : '' }` }
			style={style}
		>
			{ hasEditPermission && (
				<CardHeader
					className="carrossel-card__header"
					avatar={
						onSelectChange ? (
							<Checkbox
								checked={ !!selected }
								onChange={ (event) => onSelectChange(event.target.checked) }
								color="primary"
								size="small"
								inputProps={ { 'aria-label': 'Selecionar imagem' } }
							/>
						) : null
					}
					title={
						dragHandleProps ? (
							<IconButton
								className="carrossel-card__drag-handle"
								{...dragHandleProps}
							>
								<DragIndicatorIcon style={{ transform: 'rotate(90deg)' }} />
							</IconButton>
						) : null
					}
					action={
						<div className="carrossel-card__actions">
							<IconButton
								className="carrossel-card__edit"
								onClick={ onEdit }
								title="Editar"
								id="carrossel-card-edit-btn"
							>
								<Pencil size='18'/>
							</IconButton>
							<IconButton
								className="carrossel-card__delete"
								onClick={ onDelete }
								title="Excluir"
								id="carrossel-card-delete-btn"
							>
								<Trash size='20'/>
							</IconButton>
						</div>
					}
				/>
			) }

			<div className="carrossel-card__image-wrapper">
				<CardMedia
					component="img"
					className="carrossel-card__image"
					image={ imageUrl }
					alt={ image.nome }
					onClick={ handleImageClick }
					id="carrossel-card-image"
				/>
			</div>

			<CardContent className="carrossel-card__content">
				<span className="carrossel-card__order">Posição: { image.ordem }º</span>
				<h5 className="carrossel-card__title">{ image.nome }</h5>
			</CardContent>
		</Card>
	);
});

export default CarrosselCard;
